var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard__card" },
    [
      _vm.loaders.connections ? _c("CardLoading") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dashboard__card-content",
          class: { loadingBlur: _vm.loaders.connections }
        },
        [
          _c("div", { staticClass: "dashboard__card-header" }, [
            _c("div", { staticClass: "dashboard__card-title" }, [
              _vm._v("Connections")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "dashboard__card-title-addendum" }, [
              _vm._v(_vm._s(_vm.dataRange))
            ]),
            _vm._v(" "),
            _vm._m(0)
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "dashboard__card-body dashboard__card-body--bordered-top"
            },
            [_c("ConnectionsChart")],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "dashboard__card-title-icon dashboard__card-title-icon--fuel-utilization"
      },
      [_c("i", { staticClass: "fa fa-tasks" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }